export default __webpack_public_path__ + "static/media/betslip-background3x.df8b4bc6.png";